import { render, staticRenderFns } from "./ReceiptTable.vue?vue&type=template&id=4558f6b0&scoped=true"
import script from "./ReceiptTable.vue?vue&type=script&lang=js"
export * from "./ReceiptTable.vue?vue&type=script&lang=js"
import style0 from "./ReceiptTable.vue?vue&type=style&index=0&id=4558f6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558f6b0",
  null
  
)

export default component.exports